import styled from '@emotion/styled';

import { FontFamily } from '@/enums/index';
import { BREAKPOINTS } from '@/styles/themes/default';

import { Container } from '../core/Grid';

export const ParagraphContainer = styled.div`
  p {
    font-family: ${FontFamily.IBMPlexSans};
    margin: 0;
    font-size: 16px;
    line-height: 24px;

    @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
      font-size: 20px;
      line-height: 135%;
    }

    &:not(:last-of-type) {
      margin-bottom: 27px;
    }
  }
`;

export const Heading = styled.h2`
  font-family: ${FontFamily.SpaceGrotesk};
  font-size: 32px;
  line-height: 40px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    font-size: 48px;
    line-height: 56px;
  }
`;

export const LandingContainer = styled(Container)`
  @media (min-width: ${BREAKPOINTS.Tablet.min}px) and (max-width: ${BREAKPOINTS.Tablet.max}px) {
    max-width: 512px;
    margin: 0 auto;
  }
`;
